// room
<template>
  <div class="link-views no-bg">
    <div class="bg-div">
      <span style="display:none">{{isExpID}}</span>
      <div class="top">
        <Button type="primary" @click="goback">返回</Button>
      </div>
      <Row :gutter="16" class="hasImgDiv">
        <!-- :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="12" -->
        <i-col :xs="24" :sm="24" :md="8" :lg="6" :xl="4">
          <div class="flImg">
            <img :src="port+RoomDetails.ImgUrl" alt>
          </div>
        </i-col>

        <i-col :xs="24" :sm="24" :md="16" :lg="18" :xl="20">
          <ul>
            <li>
              <strong>实验室名称：</strong>
              <span>{{RoomDetails.RoomName}}</span>
            </li>
            <li>
              <strong>实验室编号：</strong>
              <span>{{RoomDetails.RoomNo}}</span>
            </li>
            <li>
              <strong>实验室所在楼栋：</strong>
              <span>{{RoomDetails.BuildName}}</span>
            </li>
            <li>
              <strong>实验室所在楼层：</strong>
              <span>{{RoomDetails.FloorName}}</span>
            </li>
            <li>
              <strong>负责人：</strong>
              <span>{{RoomDetails.Person}}</span>
            </li>
            <li>
              <strong>联系方式：</strong>
              <span>{{RoomDetails.PerTelPhone}}</span>
            </li>
            <li>
              <strong>实验室可做实验：</strong>
              <span>{{RoomDetails.Describes}}</span>
            </li>
          </ul>
          <div class="text-right" v-if="this.EquipmentList.length>0">
            <Button type="primary" @click="showOnline(RoomDetails)">立即预约</Button>
          </div>
          <div class="text-right" v-else>
            <Button type="primary">当前实验室无设备无法预约</Button>
          </div>
        </i-col>
      </Row>
    </div>
    <div class="bg-div">
      <strong>拥有设备</strong>
      <Table :columns="columns" :data="EquipmentList" :loading="loading">
        <template slot-scope="{row}" slot="action">
          <div class="action-table">
            <span v-if="row.SbState==1">正常使用</span>
            <span class="error" v-if="row.SbState==2">维修中</span>
            <span class="error" v-if="row.SbState==3">外借租用</span>
            <span class="error" v-if="row.SbState==4">报废</span>
            <span class="error" v-if="row.SbState==5">已坏</span>
          </div>
        </template>
      </Table>
    </div>
    <!-- 模态框 -->
    <Modal
      v-model="showfullscreen"
      fullscreen
      title="在线预约"
      :class="{'myfullscreen':true,'noLeft':isCollapsed }"
      :mask-closable="false"
    >
      <Form ref="editItem" :model="editItem" :label-width="140">
        <FormItem label="选择预约日期：" class="ivu-form-item-required">
          <DatePicker
            type="date"
            :options="options"
            placeholder="选择预约日期"
            style="width: 200px"
            @on-change="getDate"
          ></DatePicker>
        </FormItem>
        <FormItem label="选择时间段：" class="ivu-form-item-required">
          <TimePicker
            :steps="[1,15]"
            hide-disabled-options
            :disabled-hours="[0,1,2,3,4,5,6,23]"
            format="HH:mm"
            type="timerange"
            placement="bottom-start"
            placeholder="选择时间段"
            style="width: 200px"
            @on-change="getTime"
          ></TimePicker>
        </FormItem>
        <FormItem label="预约设备或房间：" class="ivu-form-item-required">
          <Checkbox v-model="single">预约房间(即当前房间所有设备)</Checkbox>
        </FormItem>
        <Table
          class="top"
          :columns="editcolumns"
          :data="EquipmentListUsable"
          :loading="loading"
          ref="selection"
          @on-selection-change="selectEquipmentList"
        ></Table>

        <FormItem label="预约原因：" prop="Describes" class="ivu-form-item-required">
          <Input clearable type="textarea" v-model="editItem.Describes"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="reset">取消</Button>
        <Button type="primary" @click="sureOnline">立即预约</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import * as homeConst from "../../../apiconfig/index.js";
import * as homeApi from "../../../api/teacher-api.js";
import * as publicApi from "../../../api/public-api.js";
import * as allFn from "../../../utils/index.js";
export default {
  name: "onlineDetails",
  data() {
    return {
      port: homeConst.baseUrl + "/", //baseurl
      loading: true,
      RoomDetails: {},
      EquipmentList: [],
      RoomId: 0,
      columns: [
        {
          title: "设备编号",
          key: "EquipmentNo",
          align: "center"
        },
        {
          title: "设备名称",
          key: "EquipmentName",
          align: "center"
        },
        {
          title: "设备状态",
          slot: "action",
          align: "center"
        }
      ],
      editcolumns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "设备编号",
          key: "EquipmentNo",
          align: "center"
        },
        {
          title: "设备名称",
          key: "EquipmentName",
          align: "center"
        }
      ],
      EquipmentListUsable: [],
      showfullscreen: false,
      single: false,
      editItem: {
        Describes: "",
        EquipmentId: [],
        RoomId: "",
        TimeEnd: "",
        TimeStart: ""
      },
      options: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      }
    };
  },
  beforeCreate() {},
  computed: {
    isCollapsed() {
      return this.$store.state.isCollapsed;
    },

    isExpID() {
      this.RoomId = this.$route.params.id;
     this.init(this.RoomId);
      return this.$route.params.id;
    }
  },
  mounted() {
     this.RoomId = this.$route.params.id;
    // this.init(this.RoomId);
  },
  watch: {
    // 是否选择所有设备
    single(val) {
      this.$refs.selection.selectAll(val);
      if (val) {
        this.editItem.EquipmentId = this.EquipmentListUsable.map(item => {
          return item.EquipmentId;
        });
      } else {
        this.editItem.EquipmentId = [];
      }
    }
  },
  methods: {
    // 初始化
    init(val) {
      this.editItem.RoomId = val;
      this.getRoomDetails(val);
      this.getEquipmentList(val);
      this.GetEquipmentUsable(val);
    },
    // 返回上一页
    goback() {
      sessionStorage.removeItem("RoomId");
      this.editItem = {
        Describes: "",
        EquipmentId: [],
        RoomId: "",
        TimeEnd: "",
        TimeStart: ""
      };
      this.RoomDetails = {};
      this.EquipmentList = [];
      this.EquipmentListUsable = [];
      this.single = false;
      this.$router.push({
        name: `online`
      });
    },
    // 获取实验室详情;
    async getRoomDetails(RoomId) {
      this.RoomDetails = await publicApi.GetRoomById({
        RoomId: RoomId
      });
    },
    // 获取设备列表
    async getEquipmentList(RoomId) {
      this.EquipmentList = await publicApi.GetEquipmentByRoomId({
        RoomId: RoomId
      });
      this.loading = false;
    },
    // 获取可用设备列表
    async GetEquipmentUsable(RoomId) {
      this.EquipmentListUsable = await publicApi.GetEquipmentUsable({
        RoomId: RoomId
      });
      this.loading = false;
    },
    //显示预约
    showOnline(item) {
      if (this.EquipmentListUsable.length > 0) {
        this.showfullscreen = true;
      } else {
        this.$Message.error({
          content: "此实验室暂无可用设备，无法预约",
          duration: 3
        });
      }
    },
    // 选择设备
    selectEquipmentList(val) {
      this.editItem.EquipmentId = val.map(item => {
        return item.EquipmentId;
      });
    },
    // 取消
    reset() {
      this.showfullscreen = false;
      this.editItem = {};
      this.RoomDetails = {};
      this.EquipmentList = [];
      this.EquipmentListUsable = [];
      this.single = false;
    },
    // 确定
    sureOnline() {
      if (this.editItem.TimeStart.length == 0) {
        this.$Message.error({
          content: "预约日期不能为空",
          duration: 3
        });
        return;
      }
      if (this.editItem.TimeEnd.length == 0) {
        this.$Message.error({
          content: "预约时间不能为空",
          duration: 3
        });
        return;
      }
      if (this.editItem.EquipmentId.length == 0) {
        this.$Message.error({
          content: "至少预约一台设备",
          duration: 3
        });
        return;
      }
      if (this.editItem.Describes.length == 0) {
        this.$Message.error({
          content: "预约原因不能为空",
          duration: 3
        });
        return;
      }
      this.$Modal.confirm({
        title: "确定预约",
        onOk: () => {
          publicApi.AddAppointment(this.editItem).then(res => {
            if (res.success) {
              this.showfullscreen = false;
              this.$Message.success({
                content: res.msg,
                duration: 3
              });
              this.$router.push({
                name: `onlineResults`
              });
            } else {
              this.$Message.error({
                content: res.msg,
                duration: 3
              });
            }
          });
        }
      });
    },
    // 获取日期
    getDate(val) {
      this.editItem.TimeStart = val;
    },
    // 获取时间段
    getTime(val) {
      if (val.length > 0) {
        this.editItem.TimeEnd = val[0] + "-" + val[1];
      }
    }
  }
};
</script>

<style scoped>
</style>